import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import {WebsiteShareSocialNetworksComponent} from './website-share-social-networks.component'
import { SocialNetworkServiceModule, SocialNetworkServiceConfig, SocialNetwork } from 'dmmp-services'


@NgModule({
  imports: [CommonModule, SharedModule, SocialNetworkServiceModule ],
  declarations: [WebsiteShareSocialNetworksComponent],
  exports: [WebsiteShareSocialNetworksComponent],
})
export class WebsiteShareSocialNetworksModule {

  constructor(@Optional() @SkipSelf() parentModule?: WebsiteShareSocialNetworksModule) {
    if (parentModule) {
      throw new Error(
        'WebsiteShareSocialNetworksModule is already loaded. Import it in the AppModule only')
    }
  }

  static forRoot(config: SocialNetworkServiceConfig): ModuleWithProviders<WebsiteShareSocialNetworksModule> {

      return {
        ngModule: WebsiteShareSocialNetworksModule,
        providers: [
          { provide: SocialNetwork, useValue: config },
        ]
      }
    }
}
